<template>
  <div
    class="content-box shadow"
    :class="elevationLevelClass"
  >
    <div
      v-if="hasHeader"
      class="header"
    >
      <slot name="header" />
    </div>
    <div class="content">
      <slot>
        Inget innehåll angivet
      </slot>
    </div>
    <div
      v-if="hasFooter"
      class="footer"
    >
      <slot name="footer" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'ContentBox',
  props: {
    elevationLevel: {
      type: Number,
      default: 1,
      validator: (value) => [1, 2, 3].includes(value),
    },
  },
  computed: {
    hasHeader() {
      return !!this.$scopedSlots.header;
    },
    hasFooter() {
      return !!this.$scopedSlots.footer;
    },
    elevationLevelClass() {
      return `elevation-${this.elevationLevel}`;
    },
  },
};
</script>

<style lang="scss" scoped>
  .content-box {
    &.shadow {
      &.elevation-1 {
        box-shadow: 0 0 3px 2px rgba(var(--shadow-color-rgb), 0.12), 0 1px 2px rgba(var(--shadow-color-rgb), 0.24);
      }

      &.elevation-2 {
        box-shadow: 0 0 3px 3px rgba(var(--shadow-color-rgb), 0.15), 0 1px 4px rgba(var(--shadow-color-rgb), 0.3);
      }

      &.elevation-3 {
        box-shadow: 0 0 3px 4px rgba(var(--shadow-color-rgb), 0.15), 0 1px 6px rgba(var(--shadow-color-rgb), 0.3);
      }

      &.hover-shadow:hover {
        box-shadow: 0 1px 4px 1px var(--shadow-color-hex);
      }
    }

    background-color: var(--primary-bg-hex);
    border-radius: 2px;
    transition: background 1s;
    padding: 10px 25px;

    .header {
      font-weight: 500;
      font-size: 18px;
      padding: 15px 0 5px 0;
      border-bottom: 1px solid var(--border-color-hex);
    }

    .content {
      padding: 20px 0;
    }

    .footer {
      padding: 5px 0;
      border-top: 1px solid var(--border-color-hex);
    }
  }

</style>
